
import { Graph } from "./Graph";
import { AStarSearch } from "./AStarSearch";
import { vec3 } from "gl-matrix";

export class PathFinder<T> {

    public graph: Graph<T>;
    public heuristic: (a: T, b: T) => number;

    public originPosition: vec3 | number[];
    public targetPosition: vec3 | number[];

    constructor() {

    }

    public setGraph(graph: Graph<T>): PathFinder<T> {
        this.graph = graph;
        return this;
    }

    public setHeuristic(heuristic: (node: T, goal: T) => number): PathFinder<T> {
        this.heuristic = heuristic;
        return this;
    }

    public findPath(start: T, goal: T, originPosition: vec3 | number[], targetPosition: vec3 | number[]): ResultPath<T> {

        this.originPosition = originPosition;
        this.targetPosition = targetPosition;

        let pathFinder = new AStarSearch(this.graph, this.heuristic);

        let result = pathFinder.search(start, goal);

        if (result.solved) {

            let path = [goal];
            let node = goal;

            while (!this.areEqual((node = result.cameFrom.get(node)), start)) {
                path.push(node);
            }

            return {
                solved: true,
                origin: originPosition,
                target: targetPosition,
                cameFrom: result.cameFrom,
                path: path.reverse()
            };

        } else {
            return {
                solved: false,
                origin: originPosition,
                target: targetPosition,
                cameFrom: result.cameFrom,
                path: null
            };
        }
    }

    protected areEqual(a: T, b: T): boolean {
        return a === b;
    }
}

export type ResultPath<T> = {
    solved: boolean,
    origin: vec3 | number[],
    target: vec3 | number[],
    cameFrom: Map<T, T>,
    path: T[]
}